export default "__VITE_ASSET__BQLUN9Po__"